module Meevo.Plugins.Register {
    "use strict";
    export class SelfPaymentsSection extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        selfPayment;
        hasHsaFsaMerchantAccount: boolean;
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Self, registerContext, "selfPayments", Register.RegisterSectionCatTypeEnum.Payment);
        }
        reset() {
            this.selfPayment = {
                sendSms: true,
                sendEmail: true
            };
            this.setHasHsaFsaMerchantAccounts();
        }
        addPayment(isValid) {
            if (!isValid) {
                return;
            }
            this.registerContext.onHold(true).then(onHoldId => {
                this.selfPayment.onHoldId = onHoldId;
                for (let selfPayment of this.registerContext.sale.selfPayments) {
                    selfPayment.onHoldId = null;
                }
                this.registerContext.dataService.customMethodData("/api/selfPayment", "post", this.selfPayment).then(() => {
                    this.registerContext.reset();
                    this.registerContext.modalService.alert("MESSAGE_SELF_PAY_CONFIRMATION", Meevo.Components.Modal.ModalTranslationModes.Translate, false, undefined, "MESSAGE_SELF_PAY_CONFIRMATION_HEADER");
                    this.registerContext.selectedSection.reset();
                }).catch(ex => {
                    if (ex.data && ex.data.responseStatus && ex.data.responseStatus.message === "MESSAGE_SELF_PAY_INVALID_CONTACT_INFO" &&
                        this.selfPayment.refreshClient) {
                        this.selfPayment.refreshClient();
                    }
                });
            })
        }
        addPaymentLabel() {
            return "LABEL_SEND_SELF_PAY";
        }
        private setHasHsaFsaMerchantAccounts() {
            this.registerContext.getHasHsaFsaMerchantAccounts().then((result) => {
                this.hasHsaFsaMerchantAccount = result;
            });
        }
    }
}